import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useAuthRedirect() {
    const location = useLocation();
    useEffect(() => {
        const setRedirectLocation = (redirectLocation) => {
            if (redirectLocation) {
                if (redirectLocation?.from?.state) {
                    setRedirectLocation(redirectLocation.from.state);
                } else {
                    if (!redirectLocation?.isRedirect) sessionStorage.setItem('from', JSON.stringify(redirectLocation));
                }
            }
        };
        if (location.state) {
            setRedirectLocation(location.state);
        }
    }, [location.state]);
}

export function setAuthRedirect(path: string) {
    const redirectLocation = {
        from: {
            pathname: path,
        },
    };
    sessionStorage.setItem('from', JSON.stringify(redirectLocation));
}
